import type { Node } from 'reactflow';

/**
 * Stable hash of the author-controlled parts of the canvas.
 *
 * React Flow adds several runtime-only fields to each node after it renders
 * and measures them.  These values are never persisted and must not count as
 * "unsaved changes":
 *
 *   - `height`, `width`, `positionAbsolute` — set after the first layout pass
 *   - `selected` — toggled whenever the author clicks a node
 *   - `dragging` — set true while the author drags a node
 *
 * Stripping them before hashing means:
 *   - Dimension updates after React Flow measures nodes don't flip the toolbar
 *     button back to "Save*" immediately after a save.
 *   - Clicking or dragging a node doesn't mark the flow as having unsaved
 *     changes.
 *   - The initial state captured after a save matches what the next render
 *     will produce once React Flow re-measures the nodes.
 */
export function stableHash(nodes: Node[], edges: unknown[]): string {
  const stripped = nodes.map(
    ({ height, width, positionAbsolute, selected, dragging, ...rest }) => rest,
  );
  return JSON.stringify({ nodes: stripped, edges });
}
